import { render, staticRenderFns } from "./LockerDeliverySteps.vue?vue&type=template&id=212aff09"
import script from "./LockerDeliverySteps.vue?vue&type=script&lang=js"
export * from "./LockerDeliverySteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports